import { responseIcon, timeIcon } from "assets/icons";
import { Button } from "components/form";
import "./SurveyStatusReport.scss";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { handleDecryptionParams } from "utils/dataCipherHelper";
import useShimmer from "hooks/useShrimmer";
import MySurveyShrimmer from "shrimmer/Survey/MySurveyShrimmer";
import {
  getSurveySummaryDetailsApi,
  getSurveySummaryDetailsGraphApi,
  getSurveySummaryListApi,
} from "services/analysis";
import { getFromLocal } from "config/axiosInstance";
import { toast } from "sonner";
import moment from "moment-timezone";
import CustomModal from "components/modals/CustomModal";
import AnalysisGraph from "../analysis/section/AnalysisGraph";
import ReportGraphicalData from "./ReportGraphicalData";
import { useTranslation } from "react-i18next";
const SurveyStatusReport = () => {
  //***************************** Handle all state and variable ************************//
  const { t } = useTranslation();
  const [blockArray, setBlockArray] = useState([]);
  const [questionData, setQuestionData] = useState(null);
  const [summaryDetails, setSummaryDetails] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showShimmer, setShowShimmer] = useShimmer(MySurveyShrimmer);

  const [selectedBlock, setSelectedBlock] = useState();
  const [selectedQuestion, setSelectedQuestion] = useState();
  const [questionArrayByBlock, setQuestionArrayByBlock] = useState();
  const [questionId, setQuestionId] = useState();
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [isPreviousDisabled, setIsPreviousDisabled] = useState(true);

  const getParamsData = handleDecryptionParams(
    searchParams.get("data"),
    setSearchParams
  );

  const [chartType, setChartType] = useState("");
  const [modalChartData, setModalChartData] = useState();
  const [isGraphModalOpen, setIsGraphModalOpen] = useState(false);
  const [blockTitleArray, setBlockTitleArray] = useState();

  //****************************** Handle All Functions ****************************//
  // get survey Details handler
  const fetchSurveySummaryDetailsListHandler = async () => {
    try {
      setShowShimmer(true);
      const reqData = {
        isWeb: true,
        token: getFromLocal(),
        surveyId: getParamsData?.surveyId,
        isAnalysis: getParamsData?.isAnalysis,
      };

      // if (search && debouncedValue) {
      //   reqData.search = debouncedValue;
      // }

      // if (surveyStatus) {
      //   reqData.surveyStatus = surveyStatus;
      // }

      const responseData = await getSurveySummaryDetailsApi(reqData);

      const { status, message, data } = responseData;
      if (status === 200) {
        setSummaryDetails(data?.surveyDetail);
        setBlockTitleArray(data?.surveyDetail?.titleArray);
        setBlockArray(data?.surveyDetail?.blocksArray);
        setQuestionData(data?.surveyDetail?.groupByBlock || null);

        // if (Number(activePage) === 1) {
        //   setSummaryDetails(data?.surveyDetail);
        // } else {
        //   setSummaryDetails((prevList) => [...prevList, ...surveyList]);
        // }
      } else {
        toast.error(message);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  // useEffect for summary details
  useEffect(() => {
    fetchSurveySummaryDetailsListHandler();

    // eslint-disable-next-line
  }, []);

  // get GraphData by category
  const getGraphDataHandler = async (type) => {
    try {
      setModalChartData();
      // setShowShimmer(true);
      const reqData = {
        token: getFromLocal(),
        surveyId: summaryDetails?._id,
        type: type,
      };

      const chartTypeMapping = {
        region: t("STRUCTURE_PREVIEW.Region"),
        gender: t("STRUCTURE_PREVIEW.Gender"),
        educationLevel: t("STRUCTURE_PREVIEW.Education Level"),
        livingSituation: t("STRUCTURE_PREVIEW.Living Situation"),
        martialStatus: t("STRUCTURE_PREVIEW.Marital Status"),
        annualIncome: t("STRUCTURE_PREVIEW.Annual Income"),
      };

      if (chartTypeMapping[type]) {
        setChartType(chartTypeMapping[type]);
      }

      const responseData = await getSurveySummaryDetailsGraphApi(reqData);

      const { status, message, data } = responseData;
      if (status === 200) {
        if (data?.length > 0) {
          setModalChartData(data);
        } else {
          toast.error("No Data to Show!");
        }
      } else {
        toast.error(message);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  useEffect(() => {
    if (modalChartData) {
      setIsGraphModalOpen(true);
    }
  }, [modalChartData]);

  // function for set question
  const setQuestionHandlerForShow = () => {
    if (questionData) {
      const firstBlock = blockArray[0];
      const questionArray = { ...questionData };
      const blockQuestionArray = questionArray[firstBlock];

      const firstQuestion = blockQuestionArray[0];

      setSelectedBlock(firstBlock);
      setQuestionId(firstQuestion?._id);
      setSelectedQuestion(firstQuestion);
      setQuestionArrayByBlock(blockQuestionArray);
    }
  };

  // onBlockChangeHandler
  const blockOnChangeHandler = (blockName) => {
    if (blockName === selectedBlock) {
      setIsNextDisabled(false);
      setIsPreviousDisabled(false);
      return;
    } else {
      setIsNextDisabled(false);
      setIsPreviousDisabled(false);
      const blockIndex = blockArray.findIndex((el) => el === blockName);

      const selectedBlock = blockArray[blockIndex];
      const questionArray = { ...questionData };
      const blockQuestionArray = questionArray[selectedBlock];

      const firstQuestion = blockQuestionArray[0];

      setSelectedBlock(selectedBlock);
      setQuestionId(firstQuestion?._id);
      setSelectedQuestion(firstQuestion);
      setQuestionArrayByBlock(blockQuestionArray);
    }
  };

  // onClick next question handler
  const onNextPrevQuestionHandler = (callType) => {
    const currentIndex = questionArrayByBlock?.findIndex(
      (el) => el?._id === questionId
    );

    let updatedIndex = currentIndex;
    if (callType === "next") {
      if (currentIndex <= questionArrayByBlock?.length - 2) {
        updatedIndex = Number(updatedIndex) + 1;
        const updatedQuestion = questionArrayByBlock[updatedIndex];
        setQuestionId(updatedQuestion?._id);
        setSelectedQuestion(updatedQuestion);
        setIsPreviousDisabled(false);
      } else {
        setIsNextDisabled(true);
        return toast.error("No More Question In Selected Section");
      }
    } else {
      if (currentIndex === 0) {
        setIsPreviousDisabled(true);
        return toast.error("Invalid Selection");
      } else {
        updatedIndex = Number(updatedIndex) - 1;
        const updatedQuestion = questionArrayByBlock[updatedIndex];
        setQuestionId(updatedQuestion?._id);
        setSelectedQuestion(updatedQuestion);
        setIsNextDisabled(false);
      }
    }
  };

  useEffect(() => {
    if (questionData && blockArray) {
      setQuestionHandlerForShow();
    }

    // eslint-disable-next-line
  }, [questionData]);

  //****************************** Handle HTML CODE ***************************//
  return (
    <>
      <div className="survey_status">
        <h3 className="dashboard_title">
          {t("FEEDBACK_SURVEY.feedbackSurvey")}
        </h3>

        <div className="survey_status_content">
          <div className="survey_details">
            <div className="card_wrap">
              <div className="_card">
                <img src={responseIcon} alt="" />
                <p>
                  <b>{summaryDetails?.surveyResponseRateTillToday}%</b>
                  <span>{t("FEEDBACK_SURVEY.averageResponseRate")}</span>
                </p>
              </div>
              <div className="_card">
                <img src={timeIcon} alt="" />
                <p>
                  <b>
                    {summaryDetails?.surveyAverageTimeTaken || 0}{" "}
                    {t("FEEDBACK_SURVEY.Min")}
                  </b>
                  <span>{t("FEEDBACK_SURVEY.averageTimeTaken")}</span>
                </p>
              </div>
            </div>
            <div className="button_wrap">
              <Button
                className="light"
                onClick={() => getGraphDataHandler("region")}
              >
                {t("STRUCTURE_PREVIEW.Region")}
              </Button>
              <Button
                className="light"
                onClick={() => getGraphDataHandler("gender")}
              >
                {t("STRUCTURE_PREVIEW.Gender")}
              </Button>
            </div>
            <div className="button_wrap">
              <Button
                className="light"
                onClick={() => getGraphDataHandler("educationLevel")}
              >
                {t("STRUCTURE_PREVIEW.Education Level")}
              </Button>
              <Button
                className="light"
                onClick={() => getGraphDataHandler("livingSituation")}
              >
                {t("STRUCTURE_PREVIEW.Living Situation")}
              </Button>
            </div>

            <div className="button_wrap">
              <Button
                className="light"
                onClick={() => getGraphDataHandler("martialStatus")}
              >
                {t("STRUCTURE_PREVIEW.Marital Status")}
              </Button>
              <Button
                className="light"
                onClick={() => getGraphDataHandler("annualIncome")}
              >
                {t("STRUCTURE_PREVIEW.Annual Income")}
              </Button>
            </div>
            <div className="basic_detail">
              <h4>{t("FEEDBACK_SURVEY.basicDetail")}</h4>
              <ul>
                <li>
                  <span>{t("FEEDBACK_SURVEY.status")}</span>
                  <span>
                    {summaryDetails?.surveyStatus === "ongoing"
                      ? "Ongoing"
                      : summaryDetails?.surveyStatus === "draft"
                      ? "Pending"
                      : "Completed"}
                  </span>
                </li>
                <li>
                  <span>{t("FEEDBACK_SURVEY.createdDate")}</span>
                  <span>
                    {moment(summaryDetails?.createdAt).format("D/MM/YYYY") ||
                      "----"}
                  </span>
                </li>
                <li>
                  <span>{t("FEEDBACK_SURVEY.surveyCategory")}</span>
                  <span>{summaryDetails?.surveyCategory?.name || "-----"}</span>
                </li>
                <li>
                  <span>{t("FEEDBACK_SURVEY.expiryDate")}</span>
                  <span>
                    {moment(summaryDetails?.expiryDate).format("D/MM/YYYY") ||
                      "----"}
                  </span>
                </li>
                <li>
                  <span>{t("FEEDBACK_SURVEY.rewardPerParticipant")}</span>
                  <span>{`${summaryDetails?.rewardPerPerson || 0} SAR`}</span>
                </li>
                <li>
                  <span>{t("FEEDBACK_SURVEY.rewardOnHold")}</span>
                  <span>{`${
                    summaryDetails?.rewardPerPerson *
                      (summaryDetails?.userCount -
                        summaryDetails?.totalParticipantCount) || 0
                  } SAR`}</span>
                </li>
                <li>
                  <span>{t("FEEDBACK_SURVEY.rewardDistributedTillNow")}</span>
                  <span>{`${
                    summaryDetails?.totalCompleteParticipant *
                      summaryDetails?.rewardPerPerson || 0
                  } SAR`}</span>
                </li>
              </ul>
              <h4>{t("FEEDBACK_SURVEY.description")}</h4>
              <p className="description">
                {summaryDetails?.description || "-----"}
              </p>
            </div>
          </div>

          <ReportGraphicalData
            blockArray={blockArray}
            titleArray={blockTitleArray}
            isNexDisable={isNextDisabled}
            selectedBlock={selectedBlock}
            getParamsData={getParamsData}
            questionIdForChart={questionId}
            isPreDisabled={isPreviousDisabled}
            selectedQuestion={selectedQuestion}
            blockOnChange={blockOnChangeHandler}
            questionChangeHandler={onNextPrevQuestionHandler}
          />

          {/* <div className="survey_response">
            <div className="book_list">
              <span className="blue">Book 1</span>
            </div>
            <div className="question">
              <h5>
                <span>1</span>Multiple Choice
              </h5>
              <h4>Which insurance company is your provider?</h4>
            </div>

            <div className="chart_view">
              <Chart
                options={chartData.options}
                series={chartData.series}
                type="bar"
              />
            </div>
            <div className="button_wrap">
              <Button className="light">Previous Question</Button>
              <Button>Next Question</Button>
            </div>
          </div> */}
        </div>
      </div>

      {/*------------ Graph Modal ------------*/}

      {modalChartData?.length > 0 && (
        <CustomModal
          className={"md"}
          show={isGraphModalOpen}
          handleClose={() => {
            setIsGraphModalOpen(false);
            setModalChartData([]);
          }}
        >
          <AnalysisGraph type={chartType} rightChartData={modalChartData} />
        </CustomModal>
      )}
    </>
  );
};

export default SurveyStatusReport;
